import Link from 'next/link'
import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { youtubeDurationToHms } from 'utils/datetime'

import PlayIcon from 'assets/icons/play-fill.svg'

interface VideoCardProps {
  thumbnailUrl: string
  title: string
  duration: string
  videoId: string
  playlistId: number
  screenName?: string
  isActive?: boolean
  onClick?: () => void
}

const VideoCard = ({
  playlistId,
  thumbnailUrl,
  title,
  duration,
  videoId,
  isActive,
  onClick,
}: VideoCardProps) => {
  return (
    <div
      className={clsx(
        'relative flex items-center px-4 py-3 border-b cursor-pointer transition-colors',
        'before:content-[""] before:absolute before:left-0 before:top-0 before:h-full before:w-1',
        isActive
          ? 'bg-blue-5 before:bg-blue-500'
          : 'hover:bg-gray-5 hover:before:bg-gray-300'
      )}
      onClick={onClick}
    >
      <div className="flex-shrink-0 flex-grow-0 relative rounded">
        <img
          className="relative w-[118px] h-[64px] object-cover object-center rounded brightness-75"
          src={thumbnailUrl ?? `https://img.youtube.com/vi/${videoId}/1.jpg`}
          alt=""
        />
        <PlayIcon
          height={24}
          width={24}
          className="absolute top-1/2 left-1/2 -ml-3 -mt-3 text-white fill-current z-10"
        />
      </div>
      <div className="ml-3 min-w-0">
        <div className="mb-1 leading-none">
          {onClick ? (
            <Text variant="body" className="line-clamp-2 overflow-ellipsis">
              {title}
            </Text>
          ) : (
            <Link
              href={`/video-inspirasi/playlists/video?id=${playlistId}&video=${videoId}`}
              passHref
              legacyBehavior
            >
              <Text
                as="a"
                variant="body"
                className="overlay-link line-clamp-2 overflow-ellipsis"
              >
                {title}
              </Text>
            </Link>
          )}
        </div>
        <Text variant="helper" color="subdued">
          {youtubeDurationToHms(duration)}
        </Text>
      </div>
    </div>
  )
}

export default VideoCard
